import type { SVGProps } from 'react'
const SvgSyVideoFile = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M13 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9h-3.5A2.5 2.5 0 0 1 13 6.5zm5.818 5a2 2 0 0 0-.41-.587L14.536 3.58a2 2 0 0 0-.537-.38v3.3A1.5 1.5 0 0 0 15.5 8z"
			clipRule="evenodd"
		/>
		<path d="M10 16.117v-4.234a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43" />
	</svg>
)
export default SvgSyVideoFile
